import type { IntlShape } from 'react-intl';
import type { RecutError } from '../doc/musicVideoErrors';
import type { CutSaveState } from '../doc/useCutAutosave';
import { timelineMessages } from '../messages/timelineMessages';
import { SAVE_STATE_MESSAGES } from '../topbar/saveStateMessages';

const ERROR_MESSAGES = {
  limit: timelineMessages.recutLimit,
  busy: timelineMessages.recutBusy,
  failed: timelineMessages.recutFailed,
} as const;

/**
 * The sentence under a recut button: the save state when the cut did not save before the recut
 * (the words of the top bar), else the refusal of the API. Null when nothing failed. Pure.
 */
export function recutErrorText(
  intl: IntlShape,
  error: RecutError | null,
  saveError: CutSaveState | null
): string | null {
  if (saveError !== null) {
    return intl.formatMessage(SAVE_STATE_MESSAGES[saveError]);
  }
  return error === null ? null : intl.formatMessage(ERROR_MESSAGES[error]);
}
